export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
